import { JsonFetch } from "@roc-digital/mxm-base/logic";
import { User } from "@roc-digital/mxm-base/data";

export async function readUsersMany(ids?: string[]): Promise<User[]> {
  return await JsonFetch<User[]>({
    method: 'POST',
    url: `${process.env.REACT_APP_AUX_API_URL}/users/read-many`,
    data: ids,
  });
}